<template>
  <v-rating
    v-model="inputValue"
    background-color="orange lighten-3"
    color="primary"
    length="5"
    size="25"
    hover
  ></v-rating>
</template>

<script>
export default {
  name: "ratingCard",
  props: ["value"],
  methods: {},
  data: () => ({}),
  computed: {
    inputValue: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit("input", value);
      },
    },
  },
};
</script>
